import React from "react";

import problem from "./problem.gif";
import InfoPane from "../UI/InfoPane";

const Body = () => (
  <p>
    BlackBox uses some advanced browser features that your browser does not appear to support. Please use a
    browser that supports features such as CSS Grid. Any modern version of Safari, Chrome, Firefox, or Edge
    should work.
  </p>
);

function Unsupported() {
  return (
    <InfoPane
      imgSrc={problem}
      imgAlt="Problem"
      title="Older browser"
      subtitle="Your browser does not support BlackBox"
      bodyRender={Body}
    />
  );
}

export default Unsupported;
